export const DefaultResourcesY1S1 = [
	20483,
	21523,
	21526,
	21401,
	21512,
	20470,
	20477,
	21402,
	20515,
	20453,
	20484,
	21398,
	21399,
];

export const DefaultResourcesY1S2 = [
	21397,
	21394,
	21528,
	20482,
	20543,
	20437,
	21405,
	21406,
	21407,
	21529,
	20444,
	20544,
	20445,
	21404,
	21408,
	21525,
	21524,
];

export const DefaultResourcesY2S1 = [
	20591,
	20490,
	20521,
	21383,
	21387,
	21395,
	20496,
	20445,
	20472,
	21384,
	21389,
	21394,
];

export const DefaultResourcesY2S2 = [
	21394,
	20570,
	20499,
	21391,
	21392,
	21388,
	20441,
	20442,
	20622,
	21393,
	21396,
];

export const DefaultResources = [
	...DefaultResourcesY1S1,
	...DefaultResourcesY1S2,
	...DefaultResourcesY2S1,
	...DefaultResourcesY2S2,
];
